
export const fetchRoadSpecialEventAudioStart = (audioRequest) => ({
  type: "FETCH_ROAD_SPECIAL_EVENT_AUDIO_START",
  payload:audioRequest
});

export const fetchRoadSpecialEventAudioSuccess = (audioResponse) => ({
  type: "FETCH_ROAD_SPECIAL_EVENT_AUDIO_SUCCESS",
  payload: audioResponse
});

export const fetchRoadSpecialEventAudioFailure = (error) => ({
  type: "FETCH_ROAD_SPECIAL_EVENT_AUDIO_FAILURE",
  payload: error
});
